import WarehouseDetailsStore from './WarehouseDetailsStore'

export default WarehouseDetailsStore
